@if (practiceName$ | async; as practiceName) {
  @if (expanded) {
    <div class="flex h-[44px] items-center justify-between">
      <h3>{{ practiceName }}</h3>
      @if (canChangePractice$ | async) {
        <button
          mat-icon-button
          ptElementTarget="sidebar-practice-selector-button"
          matTooltip="Change Practice"
          (click)="openChangePractice()"
        >
          <mat-icon>read_more</mat-icon>
        </button>
      }
    </div>
  } @else {
    <h3 class="h-[44px]">&nbsp;</h3>
  }
}
